import { motion } from "framer-motion";

export default function App() {

  return (

    <div style={styles.container}>

      {/* NAVBAR */}

      <nav style={styles.nav}>

        <h2 style={styles.logo}>
          Proof of Idea
        </h2>

        <div style={styles.links}>
          
         <a href="#timeline" style={styles.link}>
  Parcours
</a>

           <a href="#about" style={styles.link}>
  À propos
</a>

           <a href="#mistakes" style={styles.link}>
  Erreurs
</a>

          <a href="#story" style={styles.link}>
            Mon Histoire
          </a>

          <a href="#lessons" style={styles.link}>
            Leçons
          </a>

          <a href="#vision" style={styles.link}>
            Vision
          </a>

          <a href="#journal" style={styles.link}>
            Journal
          </a>

          <a href="#contact" style={styles.link}>
            Contact
          </a>

        </div>

      </nav>

      {/* HERO */}

      <section style={styles.hero}>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          style={styles.title}
        >

          Ce que la crypto m’a vraiment appris.

        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
          style={styles.subtitle}
        >

          Pas du rêve.  
          Pas des promesses.  
          Juste l’expérience réelle d’un investisseur indépendant dans le monde crypto.

        </motion.p>

      </section>

      {/* ABOUT */}

<section id="about" style={styles.section}>

  <motion.div
    whileHover={{ scale: 1.01 }}
    style={styles.bigCard}
  >

    <h2 style={styles.sectionTitle}>
      👤 Qui je suis
    </h2>

    <p style={styles.text}>
      Je ne suis ni trader professionnel,
      ni influenceur crypto.

      Je suis simplement quelqu’un qui essaie
      de comprendre ce monde depuis plusieurs années,
      avec ses erreurs,
      ses doutes,
      ses moments d’euphorie
      et ses périodes de remise en question.

      J’ai créé Proof of Idea
      pour partager une vision plus honnête
      et plus humaine de la crypto.

      Pas pour vendre du rêve.
      Mais pour documenter une vraie expérience.
    </p>

  </motion.div>

</section>

      {/* STORY */}

      <section id="story" style={styles.section}>

        <motion.div
          whileHover={{ scale: 1.02 }}
          style={styles.card}
        >

          <h2 style={styles.sectionTitle}>
            🚀 Mon Histoire
          </h2>

          <p style={styles.text}>
            J’ai découvert Bitcoin comme beaucoup :
            avec curiosité, peur et énormément de questions.

            Au début, je pensais que la crypto était
            simplement un moyen de gagner rapidement de l’argent.

            Puis j’ai compris que derrière les graphiques,
            il y avait surtout :
            la psychologie,
            les émotions,
            les erreurs,
            et l’apprentissage.

            Ce site est né de cette expérience.
          </p>

        </motion.div>

      </section>

      {/* LESSONS */}

      <section id="lessons" style={styles.section}>

        <div style={styles.grid}>

          <motion.div
            whileHover={{
              y: -10,
            }}
            style={styles.lessonCard}
          >

            <h3>
              📉 La peur fait vendre au mauvais moment
            </h3>

            <p style={styles.cardText}>
              Les plus grosses erreurs arrivent souvent pendant la panique.
            </p>

          </motion.div>

          <motion.div
            whileHover={{
              y: -10,
            }}
            style={styles.lessonCard}
          >

            <h3>
              💎 La patience vaut plus qu’un trade
            </h3>

            <p style={styles.cardText}>
              Les marchés récompensent rarement l’impatience.
            </p>

          </motion.div>

          <motion.div
            whileHover={{
              y: -10,
            }}
            style={styles.lessonCard}
          >

            <h3>
              ⚡ Les cycles changent tout
            </h3>

            <p style={styles.cardText}>
              Comprendre les cycles crypto change complètement la vision du marché.
            </p>

          </motion.div>

        </div>

      </section>

      {/* TIMELINE */}

<section id="timeline" style={styles.section}>

  <h2 style={styles.sectionTitle}>
    🕒 Mon parcours crypto
  </h2>

  <div style={styles.timeline}>

    <div style={styles.timelineItem}>
      <div style={styles.timelineDot}></div>

      <div style={styles.timelineContent}>
        <h3>2019 — Découverte du Bitcoin</h3>

        <p style={styles.cardText}>
          Première immersion dans le monde crypto.
          Beaucoup de curiosité,
          mais aussi énormément d’incompréhension.
        </p>
      </div>
    </div>

    <div style={styles.timelineItem}>
      <div style={styles.timelineDot}></div>

      <div style={styles.timelineContent}>
        <h3>2021 — Euphorie du bull market</h3>

        <p style={styles.cardText}>
          Découverte des altcoins,
          des NFT
          et des émotions extrêmes du marché.
        </p>
      </div>
    </div>

    <div style={styles.timelineItem}>
      <div style={styles.timelineDot}></div>

      <div style={styles.timelineContent}>
        <h3>2022 — Comprendre les erreurs</h3>

        <p style={styles.cardText}>
          Le bear market a changé ma vision :
          gestion du risque,
          patience
          et psychologie.
        </p>
      </div>
    </div>

    <div style={styles.timelineItem}>
      <div style={styles.timelineDot}></div>

      <div style={styles.timelineContent}>
        <h3>2025 — Création de Proof of Idea</h3>

        <p style={styles.cardText}>
          Transformer cette expérience
          en projet personnel
          et partager une vision plus humaine de la crypto.
        </p>
      </div>
    </div>

  </div>

</section>

      {/* VISION */}

      <section id="vision" style={styles.section}>

        <motion.div
          whileHover={{ scale: 1.02 }}
          style={styles.bigCard}
        >

          <h2 style={styles.sectionTitle}>
            🌌 Ma Vision
          </h2>

          <p style={styles.text}>
            Je ne crois pas aux promesses faciles.

            Je crois :
            à l’apprentissage,
            à l’indépendance financière,
            à la compréhension du marché,
            et à une approche plus intelligente de la crypto.

            Ce projet n’est pas seulement un site.
            C’est un journal d’expérience Web3.
          </p>

        </motion.div>

      </section>
       
      {/* MISTAKES */}

<section id="mistakes" style={styles.section}>

  <h2 style={styles.sectionTitle}>
    ⚠️ Les erreurs qui m’ont coûté cher
  </h2>

  <div style={styles.grid}>

    <motion.div
      whileHover={{ y: -10 }}
      style={styles.lessonCard}
    >

      <h3>
        🚨 Acheter sous émotion
      </h3>

      <p style={styles.cardText}>
        Au début, je pensais que chaque hausse allait continuer.
        J’achetais souvent trop tard,
        guidé par la peur de manquer une opportunité.
      </p>

    </motion.div>

    <motion.div
      whileHover={{ y: -10 }}
      style={styles.lessonCard}
    >

      <h3>
        📉 Ne pas prendre de profits
      </h3>

      <p style={styles.cardText}>
        Voir un portefeuille monter est grisant.
        Mais ne jamais sécuriser une partie des gains
        peut rapidement tout faire disparaître.
      </p>

    </motion.div>

    <motion.div
      whileHover={{ y: -10 }}
      style={styles.lessonCard}
    >

      <h3>
        🧠 Ignorer la psychologie
      </h3>

      <p style={styles.cardText}>
        Je pensais que la crypto était seulement technique.
        En réalité,
        la gestion émotionnelle est l’une des compétences les plus importantes.
      </p>

    </motion.div>

  </div>

</section>

      {/* JOURNAL */}

      <section id="journal" style={styles.section}>

        <h2 style={styles.sectionTitle}>
          📓 Journal Crypto
        </h2>

        <div style={styles.grid}>

          <motion.div
            whileHover={{ y: -10 }}
            style={styles.lessonCard}
          >

            <h3>
              Bitcoin m’a appris la patience
            </h3>

            <p style={styles.cardText}>
              Les émotions sont souvent l’ennemi principal des investisseurs.
              Plus le marché devient violent,
              plus il devient important de rester calme.
            </p>

          </motion.div>

          <motion.div
            whileHover={{ y: -10 }}
            style={styles.lessonCard}
          >

            <h3>
              Les cycles changent la psychologie
            </h3>

            <p style={styles.cardText}>
              En bull market tout semble facile.
              En bear market tout semble mort.
              Pourtant les meilleures opportunités arrivent souvent dans le silence.
            </p>

          </motion.div>

          <motion.div
            whileHover={{ y: -10 }}
            style={styles.lessonCard}
          >

            <h3>
              La crypto est aussi mentale
            </h3>

            <p style={styles.cardText}>
              Comprendre la psychologie du marché est parfois plus important
              que comprendre la technologie elle-même.
            </p>

          </motion.div>

        </div>

      </section>

      {/* CONTACT */}

      <section
        id="contact"
        style={styles.contactSection}
      >

        <h2 style={styles.contactTitle}>
          📩 Contact
        </h2>

        <p style={styles.contactText}>
          contact@proof-of-idea.com
        </p>

      </section>

    </div>

  );
}

const styles = {

  container: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top, #172554 0%, #020617 60%)",
    color: "white",
    fontFamily: "Arial",
    overflowX: "hidden",
  },

  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "25px 5%",
    position: "sticky",
    top: 0,
    background: "rgba(2,6,23,0.8)",
    backdropFilter: "blur(12px)",
    zIndex: 100,
    flexWrap: "wrap",
  },

  logo: {
    fontSize: "32px",
    fontWeight: "bold",
    color: "#f7931a",
  },

  links: {
    display: "flex",
    gap: "25px",
    flexWrap: "wrap",
  },

  link: {
    color: "#cbd5e1",
    textDecoration: "none",
    transition: "0.3s",
  },

  hero: {
    textAlign: "center",
    paddingTop: "140px",
    paddingBottom: "140px",
    width: "90%",
    maxWidth: "1100px",
    margin: "auto",
  },

  title: {
    fontSize: "clamp(48px, 8vw, 90px)",
    fontWeight: "900",
    lineHeight: 1.1,
  },

  subtitle: {
    fontSize: "clamp(20px, 3vw, 28px)",
    color: "#94a3b8",
    marginTop: "40px",
    lineHeight: 1.7,
    whiteSpace: "pre-line",
  },

  section: {
    width: "90%",
    maxWidth: "1200px",
    margin: "auto",
    paddingBottom: "120px",
  },

  card: {
    background:
      "rgba(15,23,42,0.75)",
    padding: "50px",
    borderRadius: "30px",
    border:
      "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(10px)",
  },

  bigCard: {
    background:
      "linear-gradient(135deg, rgba(15,23,42,0.9), rgba(30,41,59,0.8))",
    padding: "60px",
    borderRadius: "30px",
    border:
      "1px solid rgba(255,255,255,0.08)",
  },

  sectionTitle: {
    fontSize: "48px",
    marginBottom: "30px",
  },

  text: {
    color: "#cbd5e1",
    fontSize: "22px",
    lineHeight: 1.9,
    whiteSpace: "pre-line",
  },

  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(280px,1fr))",
    gap: "30px",
  },

  lessonCard: {
    background:
      "rgba(15,23,42,0.8)",
    padding: "40px",
    borderRadius: "24px",
    border:
      "1px solid rgba(255,255,255,0.08)",
  },

  cardText: {
    color: "#94a3b8",
    marginTop: "20px",
    lineHeight: 1.7,
  },

  contactSection: {
    textAlign: "center",
    paddingBottom: "120px",
  },

  contactTitle: {
    fontSize: "48px",
    marginBottom: "20px",
  },

  contactText: {
    color: "#94a3b8",
    fontSize: "24px",
  },

};